import $ from "jquery";
import { smoothscroll } from "../utils/smoothscroll";
import { debounce } from "../utils/functions";

const $document = $(document);
const studyProgramBlockEl = $(".study-program-block");

$(function () {
  if (studyProgramBlockEl.length > 0) {
    studyProgramBlockEl.each(function () {
      studyProgramBlock($(this));
    });
  }
});

$document.on("click", ".study-program-item", function (event) {
  event.preventDefault();
});

$document.on("mousedown", ".study-program-item", function (event) {
  const $thisEl = $(this);
  const originUrl = new URL($thisEl.attr("href"));
  originUrl.searchParams.delete("rup");
  const href = originUrl.href;
  const url = new URL(window.location);
  const encodeUrl = btoa(url);

  switch (event.which) {
    case 1:
      window.location.href = href + "?rup=" + encodeUrl;
      break;
    case 2:
      window.open(href + "?rup=" + encodeUrl);
      break;
    case 3:
      $thisEl.attr("href", href + "?rup=" + encodeUrl);
      break;
  }
});

const studyProgramBlock = (element) => {
  const filter = {
    lang: element.data("lang"),
    heading: element.data("heading"),
    page: 1,
    search: "",
    type: "",
    language: "",
    form: "",
    area: [],
    faculty: [],
  };

  bindStudyProgram(element, filter);
  bindStudyProgramFilter(element, filter);

  const url = new URL(window.location);
  const sps = url.searchParams.get("sps");
  const t = url.searchParams.get("t");
  const l = url.searchParams.get("l");
  const f = url.searchParams.get("f");
  const ai = url.searchParams.get("ai");
  const fi = url.searchParams.get("fi");
  const sb = url.searchParams.get("sb");

  if (
    sps != null ||
    t != null ||
    l != null ||
    f != null ||
    ai != null ||
    fi != null ||
    sb != null
  ) {
    filter.page = 1;
    filter.search = element.find("input[name='studyProgram-search']").val();
    filter.type = element.find("input[name='studyProgram-type']:checked").val();
    filter.language = element
      .find("input[name='studyProgram-language']:checked")
      .val();
    filter.form = element.find("input[name='studyProgram-form']:checked").val();
    filter.area = element.find("select[name='studyProgram-area']").val();
    filter.faculty = element.find("select[name='studyProgram-faculty']").val();

    reRenderStudyProgram(element, filter);
  }
};

const reRenderStudyProgram = async (element, filter, append = false) => {
  const data = await getStudyProgram(filter);

  if (data != null) {
    if (append) {
      const blockContent = element.find(".study-program-block__content");
      const headdings = blockContent.find(
        ".study-program-block__faculty-heading"
      );
      const lastHeading = headdings.last();
      const dataHtml = $(data.html);
      const firstHeading = $(dataHtml[0]);

      blockContent.append(data.html);

      const newHeadings = blockContent.find(
        ".study-program-block__faculty-heading"
      );
      let lastElement = null;

      newHeadings.each(function () {
        const $thisEl = $(this);
        const thisHtml = $thisEl.html();
        if (thisHtml == lastHeading.html() && thisHtml == firstHeading.html()) {
          lastElement = $thisEl;
        }
      });

      if (lastElement != null) {
        lastElement.remove();
      }
    } else {
      element.find(".study-program-block__content").html(data.html);
    }
  }
};

const bindStudyProgram = (element, filter) => {
  element.on("click", ".showMoreButton__item", function () {
    const $thisEl = $(this);
    filter.page = $thisEl.data("page");
    $thisEl.parent().remove();
    reRenderStudyProgram(element, filter, true);
  });
};

const bindStudyProgramFilter = (element, filter) => {
  element.on(
    "input",
    "input[name='studyProgram-search']",
    debounce(
      function () {
        filter.page = 1;
        filter.search = element.find("input[name='studyProgram-search']").val();
        const url = new URL(window.location);
        filter.search != ""
          ? url.searchParams.set("sps", filter.search)
          : url.searchParams.delete("sps");

        filter.faculty = element
          .find("select[name='studyProgram-faculty']")
          .val();
        filter.faculty != ""
          ? url.searchParams.set("fi", filter.faculty)
          : url.searchParams.delete("fi");

        window.history.replaceState({}, "", url);
        reRenderStudyProgram(element, filter);
      },
      false,
      400
    )
  );

  element.on("keyup", "input[name='studyProgram-search']", function (ev) {
    ev.key === "Enter" &&
      smoothscroll(element.find(".study-program-block__content"), "header");
  });

  element.on("click", "input[name='studyProgram-type']", function () {
    const $thisEl = $(this);
    const url = new URL(window.location);
    if ($thisEl.val() == url.searchParams.get("t")) {
      $thisEl.prop("checked", false);
      filter.page = 1;
      filter.type = "";
      url.searchParams.delete("t");
      window.history.replaceState({}, "", url);
      reRenderStudyProgram(element, filter);
    }
  });

  element.on("change", "input[name='studyProgram-type']", function () {
    filter.page = 1;
    filter.type = $(this).val();
    const url = new URL(window.location);
    filter.type != ""
      ? url.searchParams.set("t", filter.type)
      : url.searchParams.delete("t");

    filter.faculty = element.find("select[name='studyProgram-faculty']").val();
    filter.faculty != ""
      ? url.searchParams.set("fi", filter.faculty)
      : url.searchParams.delete("fi");

    window.history.replaceState({}, "", url);
    reRenderStudyProgram(element, filter);
  });

  element.on("click", "input[name='studyProgram-language']", function () {
    const $thisEl = $(this);
    const url = new URL(window.location);
    if ($thisEl.val() == url.searchParams.get("l")) {
      $thisEl.prop("checked", false);
      filter.page = 1;
      filter.language = "";
      url.searchParams.delete("l");
      window.history.replaceState({}, "", url);
      reRenderStudyProgram(element, filter);
    }
  });

  element.on("change", "input[name='studyProgram-language']", function () {
    filter.page = 1;
    filter.language = $(this).val();
    const url = new URL(window.location);
    filter.language != ""
      ? url.searchParams.set("l", filter.language)
      : url.searchParams.delete("l");

    filter.faculty = element.find("select[name='studyProgram-faculty']").val();
    filter.faculty != ""
      ? url.searchParams.set("fi", filter.faculty)
      : url.searchParams.delete("fi");

    window.history.replaceState({}, "", url);
    reRenderStudyProgram(element, filter);
  });

  element.on("click", "input[name='studyProgram-form']", function () {
    const $thisEl = $(this);
    const url = new URL(window.location);
    console.log($thisEl.val());console.log(url.searchParams.get("f"));
    if ($thisEl.val() == url.searchParams.get("f")) {
      $thisEl.prop("checked", false);
      filter.page = 1;
      filter.form = "";
      url.searchParams.delete("f");
      window.history.replaceState({}, "", url);
      reRenderStudyProgram(element, filter);
    }
  });

  element.on("change", "input[name='studyProgram-form']", function () {
    filter.page = 1;
    filter.form = $(this).val();
    const url = new URL(window.location);
    filter.form != ""
      ? url.searchParams.set("f", filter.form)
      : url.searchParams.delete("f");

    filter.faculty = element.find("select[name='studyProgram-faculty']").val();
    filter.faculty != ""
      ? url.searchParams.set("fi", filter.faculty)
      : url.searchParams.delete("fi");

    window.history.replaceState({}, "", url);
    reRenderStudyProgram(element, filter);
  });

  element.on("change", "select[name='studyProgram-area']", function () {
    filter.page = 1;
    filter.area = $(this).val();
    const url = new URL(window.location);
    filter.area != ""
      ? url.searchParams.set("ai", filter.area)
      : url.searchParams.delete("ai");

    filter.faculty = element.find("select[name='studyProgram-faculty']").val();
    filter.faculty != ""
      ? url.searchParams.set("fi", filter.faculty)
      : url.searchParams.delete("fi");

    window.history.replaceState({}, "", url);
    reRenderStudyProgram(element, filter);
  });

  element.on("change", "select[name='studyProgram-faculty']", function () {
    filter.page = 1;
    filter.faculty = $(this).val();
    const url = new URL(window.location);
    filter.faculty != ""
      ? url.searchParams.set("fi", filter.faculty)
      : url.searchParams.delete("fi");

    window.history.replaceState({}, "", url);
    reRenderStudyProgram(element, filter);
  });

  element.on(
    "click",
    "button[name='search-study-program-filter']",
    function () {
      filter.page = 1;
      const $thisEl = $(this);
      const parent = $thisEl.parent().parent();
      filter.search = parent.find("input[name='studyProgram-search']").val();
      filter.type = parent
        .find("input[name='studyProgram-type']:checked")
        .val();
      filter.language = parent
        .find("input[name='studyProgram-language']:checked")
        .val();
      filter.form = parent
        .find("input[name='studyProgram-form']:checked")
        .val();
      filter.area = parent.find("select[name='studyProgram-area']").val();
      filter.faculty = parent.find("select[name='studyProgram-faculty']").val();

      const url = new URL(window.location);
      url.searchParams.set("sb", "1");
      window.history.replaceState({}, "", url);
      reRenderStudyProgram(element, filter);
    }
  );

  element.on(
    "click",
    "button[name='remove-study-program-filter']",
    function () {
      filter.page = 1;
      filter.search = "";
      filter.type = "";
      filter.language = "";
      filter.form = "";
      filter.area = [];
      filter.faculty = [];

      const $thisEl = $(this);
      const parent = $thisEl.parent().parent();
      parent.find("input[name='studyProgram-search']").val("");
      parent.find("input[name='studyProgram-type']").prop("checked", false);
      parent.find("input[name='studyProgram-language']").prop("checked", false);
      parent.find("input[name='studyProgram-form']").prop("checked", false);
      const area = parent.find("select[name='studyProgram-area']");
      area.val([]).trigger("change.select2");
      const faculty = parent.find("select[name='studyProgram-faculty']");
      faculty.val([]).trigger("change.select2");

      const url = new URL(window.location);
      url.searchParams.delete("sps");
      url.searchParams.delete("t");
      url.searchParams.delete("l");
      url.searchParams.delete("f");
      url.searchParams.delete("ai");
      url.searchParams.delete("fi");
      url.searchParams.delete("sb");
      window.history.replaceState({}, "", url);

      $(".study-program-block__content").html("");
    }
  );
};

const getStudyProgram = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + `/wp-json/mendelu/v1/study-program-block/html`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};
